/**
 * @ngdoc service
 * @name billing.invoice_templates.factory:InvoiceTemplates
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoice_templates')
    .factory('InvoiceTemplate', [
        '$translate',
        'Resource',
        InvoiceTemplate
    ]);

function InvoiceTemplate($translate, Resource) {
    var $model = Resource.make('billing/invoices/templates');
    $model.title = 'Invoice Templates';

    $model.schema = {
        type: 'object',
        title: $translate.instant('billing.invoice_templates.title'),
        properties: {
            id: {
                title: $translate.instant('billing.invoice_templates.labels.id'),
                type: 'number',
                listview: 'hidden',
                mergeable: false
            },
            title: {
                title: $translate.instant('billing.invoice_templates.labels.title'),
                type: 'string',
                columnDef: {
                    main: true
                }
            },
            number_circle_id: {
                title: $translate.instant('billing.invoice_templates.labels.number_circle_id'),
                type: 'number',
                listview: 'hidden'
            },
            subject: {
                title: $translate.instant('billing.invoice_templates.labels.subject'),
                type: 'string'
            },
            text1: {
                title: $translate.instant('billing.invoice_templates.labels.text1'),
                type: 'string',
                'x-schema-form': {
                    type: 'textarea'
                }
            },
            text2: {
                title: $translate.instant('billing.invoice_templates.labels.text2'),
                type: 'string',
                'x-schema-form': {
                    type: 'textarea'
                }
            },
            text3: {
                title: $translate.instant('billing.invoice_templates.labels.text3'),
                type: 'string',
                'x-schema-form': {
                    type: 'textarea'
                }
            },
            processing_costs_general: {
                title: $translate.instant('billing.invoice_templates.labels.processing_costs_general'),
                type: 'number'
            },
            processing_costs_per_person: {
                title: $translate.instant('billing.invoice_templates.labels.processing_costs_per_person'),
                type: 'number'
            },
            tax_rate: {
                title: $translate.instant('billing.invoice_templates.labels.tax_rate'),
                type: 'number'
            }
        }
    };

    $model.form = [
        'title',
        'text1',
        'text2',
        'text3',
        'subject',
        'tax_rate'
    ];

    return $model;
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoice_templates/factories/invoice_template-factory.js